import React from 'react';
import classNames from 'classnames';

function Spinner({
  spinnerClassName = '',
  containerClassName = '',
  spinnerStyle = null,
  containerPosition,
  spinnerPosition,
}) {
  const spinnerElementClasses = classNames('ws-spinner__element', spinnerClassName, {
    'ws-spinner__element--centered': spinnerPosition === 'center',
  });
  const spinnerContainerClasses = classNames('ws-spinner', containerClassName, {
    'ws-spinner--bottom': containerPosition === 'bottom',
    'ws-spinner--center': containerPosition === 'center',
  });

  return (
    <div className={spinnerContainerClasses}>
      <div className={spinnerElementClasses} style={spinnerStyle}>
        <div className="ws-spinner__item" />
      </div>
    </div>
  );
}

export default Spinner;
